<template>
  <main class="object1-page">
    <div style="font-size: 16px; font-weight: bold; margin:5px">
      {{ $t('object1Page.object1') }}
    </div>
    <div v-if="object1"
         class="container"
    >
      <ItemGrid :normal-columns="4"
                :normal-rows="-1"
                :xs-columns="1"
                :xs-rows="-1"
      >
        <MainInput :text="object1.Name"
                   type="text"
                   name="Object1Name"
                   :placeholder="$t('object1Page.name')"
                   :is-readonly="true"
        />

        <MainInput :text="object1.Customer.Name"
                   type="text"
                   name="Customer"
                   :placeholder="$t('object1Page.customer')"
                   :is-readonly="true"
        />
      </ItemGrid>

      <div>
        <MainButton :button-text="$t(`taskPage.embedDocument`)"
                    type="button"
                    style="height:50px; width: 16%; margin-bottom:1rem; min-width: 160px;"
                    @click="openFileExplorer"
        />
        <input v-show="false"
               id="file1"
               ref="fileInput"
               type="file"
               multiple="multiple"
               @change="onChange"
        >
        <div class="progress-wrapper">
          <div id="progress-bar-file1"
               class="progress"
          />
        </div>
      </div>
      <div>
        <table class="styled-table">
          <thead>
            <tr>
              <th @click="toggleDocumentTable">
                {{ isDocumentTableVisible ? '▼' : '▲' }} {{ $t('taskPage.documents') }}
              </th>
              <th />
              <th />
            </tr>
          </thead>
          <thead>
            <tr>
              <th
                @click="setSort({ key: 'Name', reverse: false })"
              >
                {{ $t('taskPage.documentName') }}
              </th>
              <th>
                {{ $t('taskPage.documentFileExtension') }}
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr v-for="document in object1.Documents"
                v-show="isDocumentTableVisible"
                :key="document.Id"
                class="taskRow"
            >
              <td class="tdTask">
                {{ document.Name }}
              </td>
              <td class="tdTask">
                {{ document.Extension }}
              </td>
              <td style="cursor: pointer; text-align: right; padding-right:10px;"
                  @click="downloadFile(document)"
              >
                <span class="material-icons">download</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <TaskList :tasks="tasks"
                  show-header="true"
                  :header-text="$t('object1Page.tasks')"
                  :table-columns="['Nr', 'Priority', 'TaskDescription', 'Status', 'Owner', 'Performers', 'PlannedDate', 'Object1']"
        />
      </div>
      <br>
      <div>
        <TaskList v-if="object1.Level === 1 || object1.Level === 0"
                  :tasks="object1.Children"
                  show-header="true"
                  :header-text="object1.Level === 0 ? $t('object1Page.object2s') : $t('object1Page.object3s')"
                  object-type="objects"
                  :table-columns="['Name', 'Customer']"
        />
      </div>
    </div>
  </main>
</template>
<script setup>
import TaskList from '@/components/task/TaskList.vue'
import ItemGrid from '@/components/grid/ItemGrid.vue'
import MainInput from '@/components/inputs/MainInput.vue'
import MainButton from '@/components/buttons/MainButton.vue'
import { defineProps, onMounted, computed, watch, ref } from 'vue'
import { useStore } from 'vuex'
import { PostDocument } from '@/api/document.js'
import { useToast } from 'vue-toastification'
import i18n from '@/locales/i18n'
const store = useStore()

const object1 = computed(() => store.state.object1.currentObject1)
const tasks = computed(() => store.state.object1.tasks)
const toast = useToast()
const props = defineProps({
  id: {
    type: Number,
    required: true
  }
})

const fileInput = ref(null)

const openFileExplorer = () => {
  fileInput.value.click()
}

const allowedExtensions = computed(() => store.state.document.allowedExtensions)
onMounted(async () => {
  store.dispatch('document/getAllowedFileExtensions')
  store.dispatch('object1/getObjectById', props.id)
  store.dispatch('object1/getTasksByObject1Id', props.id)
})

async function onChange () {
  const input = fileInput.value

  const formdata = new FormData()

  let allFilesAllowed = true
  for (const file of input.files) {
    const fileParts = file.name.split('.')
    const fileExtension = fileParts[fileParts.length - 1]
    if (allowedExtensions.value.indexOf(fileExtension) === -1) {
      allFilesAllowed = false
      break
    }
  }

  if (!allFilesAllowed) {
    toast.info(i18n.global.t('documentPage.fileTypesNotAllowed') + allowedExtensions.value.join(', '))
    return
  }

  for (const file of input.files) {
    formdata.append('file', file)
  }
  try {
    const postResponse = await PostDocument('object1', object1.value.Id, formdata)
    // console.log(postResponse)
    if (postResponse.status === 200) {
      store.dispatch('object1/getObjectById', props.id)
      toast.success(i18n.global.t('documentPage.uploadSuccess'))
    } else {
      toast.warning(i18n.global.t('documentPage.uploadFail'))
    }
  } catch (e) {
    toast.warning(e.message)
  }
}

const isDocumentTableVisible = ref(true)
const toggleDocumentTable = () => {
  isDocumentTableVisible.value = !isDocumentTableVisible.value
}

async function downloadFile (documentInfo) {
  try {
    const byteCharacters = window.atob(documentInfo.Base64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512)
      const byteNumbers = new Array(slice.length)

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: 'application/' + documentInfo.Extension })

    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = documentInfo.Name + '.' + documentInfo.Extension
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(link.href)
  } catch (e) {
    console.error('Error during file download:', e)
    toast.error(i18n.global.t('documentPage.DownloadFailed') + '\r\n\r\n' + e.message)
  }
}

onMounted(() => {
  store.dispatch('object1/getObjectById', props.id)
  store.dispatch('object1/getTasksByObject1Id', props.id)
})
watch(() => props.id, (newId, oldId) => {
  store.dispatch('object1/getObjectById', newId)
  store.dispatch('object1/getTasksByObject1Id', newId)
})
</script>

<style lang="scss" scoped>
.object1-page {
  height: 100%;
  overflow: scroll;
  background: var(--mainBackground);
  .container{
    padding: 1rem;
  }
}

.styled-table {
  table-layout: fixed;
  border-collapse: collapse;
  margin: 35px 0;
  font-size: 0.9em;
  font-family: 'Lexend', sans-serif;
  width: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.styled-table thead tr {
  background-color: var(--mainBlue);
  color: white;
  text-align: left;
  cursor: pointer;
}

.styled-table th {
  padding: 12px 15px;
  text-align: left;
}

.styled-table tbody tr {
  border-bottom: 1px solid lightgrey;
  background-color: white;
  color: black;
}

.styled-table tbody tr:nth-of-type(4n-1),
.styled-table tbody tr:nth-of-type(4n) {
  background-color: var(--alternatingListColor);
  color: black;
}
.taskRow{
  border-bottom: 1px solid lightgrey;
  background-color: white;
  color: black;
  height: 20px;

  .header{
    font-weight: bold;
  }
}

.taskRow:nth-of-type(2n) {
  background-color: var(--alternatingListColor);
  color: black;
}

.taskRow:last-of-type {
  border-bottom: 3px solid var(--mainBlue);
}

.tdTask {
  padding: 10px 15px;
  text-align: left;
  transition: padding 0.4s ease;

}
.textarea-container {
  position: relative;
}

.textarea-container textarea {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: none;
}

.textarea-container button {
  position: absolute;
  right: 0;
  bottom: 10px;
  right: 10px;
  padding: 12px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.textarea-container button:hover {
  background-color: #45a049;
}
</style>
